window.VH = window.VH === undefined ? {} : window.VH;
VH.ClientObjectAtUser = {
    clientListContainer : null,
    clientListToggleClass : 'bg-gray-900 text-white',
    clientAddBtn : null,
    objectListContainer : null,
    objectCheckboxSelector : '[data-role="objectCheckbox"]',
    s2ClientList : null,
    btChangeAll : null,

    initClientList : function initClientList()
    {
        let _t = VH.ClientObjectAtUser;

        _t.loadClientList();

        _t.clientListContainer.on('click', 'tbody tr', function() {
            let tr = $(this),
                clientCode = tr.data('key');
            $('tr', _t.clientListContainer).removeClass(_t.clientListToggleClass);
            tr.addClass(_t.clientListToggleClass);
            _t.loadObjectList(
                undefined,
                {
                    clientCode: clientCode,
                },
                function() {
                    _t.objectListContainer.data('client-code', clientCode);
                }
            );
        });

        _t.clientListContainer.on('click', 'a', function(e) {
            let t = $(this),
                href = t.attr('href');

            e.preventDefault();
            if (href !== '#') {
                _t.loadClientList(href);
            }
            return false;
        });
    },

    initObjectList : function initObjectList()
    {
        let _t = VH.ClientObjectAtUser;

        _t.objectListContainer.on('click', 'a', function() {
            let t = $(this),
                href = t.attr('href');

            if (href !== '#') {
                _t.loadObjectList(href);
            }
            return false;
        });

        _t.objectListContainer.on('click', _t.objectCheckboxSelector, function(event) {
            event.stopPropagation();
        });

        _t.objectListContainer.on('click', 'tbody tr', function() {
            let cb = $(this).find(_t.objectCheckboxSelector);
            cb.trigger('click');
            // cb.prop('checked', !cb.prop('checked'));
            // cb.trigger('change');
            return false;
        });

        _t.objectListContainer.on('change', _t.objectCheckboxSelector, function(event) {
            let cb = $(this);
            $.post(_t.objectListContainer.data('change-url'), {
                clientCode : _t.objectListContainer.data('client-code'),
                objectCode : cb.data('object'),
            });
        });

        _t.btChangeAll.on('click', 'button', function() {
            $.post(
                _t.objectListContainer.data('change-all-url'),
                {
                    clientCode : _t.objectListContainer.data('client-code'),
                    action : $(this).data('action'),
                },
                function() {
                    _t.loadObjectList(
                        undefined,
                        {
                            clientCode: _t.objectListContainer.data('client-code'),
                        }
                    );
                }
            );
            return false;
        });

    },

    loadList : function loadList(container, url, params, onLoad) {
        params = params === undefined ? {} : params;

        $.get(url, params, function(data) {
            container.html(data);
            if (onLoad !== undefined) {
                onLoad();
            }
        });
    },

    loadClientList : function loadClientList(url, params, onLoad)
    {
        let _t = VH.ClientObjectAtUser;
        url = url === undefined ? _t.clientListContainer.data('url') : url;
        _t.loadList(_t.clientListContainer, url, params, onLoad);
    },

    loadObjectList : function loadObjectList(url, params, onLoad)
    {
        let _t = VH.ClientObjectAtUser;
        url = url === undefined ? _t.objectListContainer.data('url') : url;
        _t.loadList(_t.objectListContainer, url, params, onLoad);
    },

    initAddClientButton : function initAddClientButton() {
        let _t = VH.ClientObjectAtUser;
        _t.clientAddBtn.on('click', function() {
            let clientCode = _t.s2ClientList.val();
            $.post(_t.clientAddBtn.data('url'), {clientCode : clientCode}, function() {
                _t.loadClientList(undefined, undefined, function() {
                    _t.clientListContainer
                        .find('tbody tr[data-key="' + clientCode + '"]')
                        .trigger('click');
                });
            });
        });
    },

    init : function init() {
        let _t = VH.ClientObjectAtUser;
        _t.clientListContainer = $('#clientList');
        _t.objectListContainer = $('#objectList');
        _t.s2ClientList = $('#ddClientList');
        _t.clientAddBtn = $('#addClient');
        _t.btChangeAll = $('#btChangeAll');

        _t.initClientList();
        _t.initObjectList();
        _t.initAddClientButton();
    }
};
